import { DeveloperCenterIcon } from '@hcs/design-system';
import { AppConfig, AppSlugs } from '@hcs/types';

import DeveloperCenterProductImage from '../../assets/product-images/developer-center-image.png';

export const APP_CONFIG_DEVELOPER_CENTER: AppConfig = {
  applicationKey: 'developer-center',
  name: 'Developer Center',
  rootPath: `/developer-center`,
  type: 'product',
  appSlugForEngagement: AppSlugs.DeveloperCenter,
  Icon: DeveloperCenterIcon,
  descriptionLong:
    'Generate Production and Test API keys and view additional information about our APIs.',
  descriptionShort:
    'Generate Production and Test API keys and view additional information about our APIs.',
  marketingImage: DeveloperCenterProductImage,
};

export const VIEW_PATHS_DEVELOPER_CENTER = {
  API_KEYS: 'api-keys',
} as const;
